const prefix = 'DimPurchaseOrderItem';

export enum DimPurchaseOrderItemField {
  ID = `${prefix}.id`,
  PRIMARY_SOURCE_REFERENCE = `${prefix}.primarySourceReference`,
  STATUS = `${prefix}.status`,
  LINE_ITEM_NUMBER = `${prefix}.lineItemNumber`,
  TITLE = `${prefix}.title`,
  PRICE_PER_UNIT = `${prefix}.pricePerUnit`,
  QUANTITY = `${prefix}.quantity`,
  VALUE = `${prefix}.value`,
  CURRENCY = `${prefix}.currency`,
  EXCHANGE_RATE = `${prefix}.exchangeRate`,
  IS_INVOICE_FINAL = `${prefix}.isInvoiceFinal`,
  IS_DELIVERY_FINAL = `${prefix}.isDeliveryFinal`,
  IS_DELIVERY_RECEIVED = `${prefix}.isDeliveryReceived`,
  IS_INVOICE_RECEIVED = `${prefix}.isInvoiceReceived`,
  IS_INVOICE_EXAMINATION_REQUIRED = `${prefix}.isInvoiceExaminationRequired`,
  IS_RETURN_ITEM = `${prefix}.isReturnItem`,
  PURCHASE_ORDER_ID = `${prefix}.purchaseOrderId`,
  PURCHASE_REQUISITION_ITEM_ID = `${prefix}.purchaseRequisitionItemId`,
  COMMODITY_GROUP_ID = `${prefix}.commodityGroupId`,
  COMMODITY_ID = `${prefix}.commodityId`,
  CONTRACT_ITEM_ID = `${prefix}.contractItemId`,
  ORGANIZATION_ID = `${prefix}.organizationId`,
  UNIT_ID = `${prefix}.unitId`,
  SUBMISSION_PERIOD_EXPIRES_AT = `${prefix}.submissionPeriodExpiresAt`,
  CREATED_AT = `${prefix}.createdAt`,
  UPDATED_AT = `${prefix}.updatedAt`,
  DESCRIPTION = `${prefix}.description`,
  COUNT = `${prefix}.count`,
}
